import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { GenerateRecommendedPetitionAngles } from './api.graphql';
import type {
	GenerateRecommendedPetitionAnglesMutation,
	GenerateRecommendedPetitionAnglesMutationVariables,
} from './api.graphql';

type Input = { mainPrompt: string; personalStory?: string };

type Recommendation = { id: string; recommendation: string; why: string };
type GenerateRecommendedPetitionAnglesReturn = Recommendation[];

export async function generateRecommendedPetitionAngles(
	input: Input,
	{ gql: { fetch }, tracker }: UtilityContext,
): Promise<GenerateRecommendedPetitionAnglesReturn> {
	try {
		void tracker.track('sap_ai_petition_recommendations_generate');

		const { data } = await fetch<
			GenerateRecommendedPetitionAnglesMutation,
			GenerateRecommendedPetitionAnglesMutationVariables
		>({
			query: GenerateRecommendedPetitionAngles,
			path: '/generate-recommended-petition-angles',
			variables: { input },
			rejectOnError: true,
		});

		if (data.generateRecommendedPetitionAngles.__typename === 'GenerateRecommendedPetitionAnglesUnhandledError') {
			throw new Error(data.generateRecommendedPetitionAngles.message ?? 'Failed to generate recommendations');
		}

		void tracker.track('sap_ai_petition_recommendations_generate_loaded');
		return [...data.generateRecommendedPetitionAngles.recommendations];
	} catch (error) {
		void tracker.track('sap_ai_petition_recommendations_generate_error');

		throw error;
	}
}
